import { render, staticRenderFns } from "./PreferredStreamNotification.vue?vue&type=template&id=351e26de&"
import script from "./PreferredStreamNotification.vue?vue&type=script&lang=js&"
export * from "./PreferredStreamNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports